import { render, staticRenderFns } from "./ConsumerDashboardSmartPostpaid.vue?vue&type=template&id=3213f2c4&scoped=true&"
import script from "./ConsumerDashboardSmartPostpaid.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardSmartPostpaid.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardSmartPostpaid.vue?vue&type=style&index=0&id=3213f2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213f2c4",
  null
  
)

export default component.exports